import '@vfde-brix/image-text/dist/styles.css';

import { createImageTextComponent } from '@vfde-brix/image-text';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-image-text');

for (let i = 0, x = elements.length; i < x; i += 1) {

    createImageTextComponent(elements[i], NO_PATTERN_BUSINESS_LOGIC);

}
